import goodLogo from "../assets/images/nav-logo.png";
import goodAdd from "../assets/images/add-btn.png";
import goodIcon from "../assets/images/good-icon.png";
import lookIcon from "../assets/images/look-icon.png";
import successImg from "../assets/images/success.png";

const GOOD_CONFIG = {
  assets: {
    logo: goodLogo,
    add: goodAdd,
    good: goodIcon,
    look: lookIcon,
    success: successImg,
  },
  style: {
    "primary-color": "#916da8",
    "primary2-color": "#8149a4",
    "primary3-color": "#a166c6",
    "evaluate-border":
      "linear-gradient(to right, #8e54ca 0%, #f0b0b6 50%, #f9e0b2 100%)",
    "evaluate-active":
      "linear-gradient(to right, rgba(142, 84, 202, 0.2) 0%, rgba(240, 176, 182, 0.2) 50%, rgba(249, 224, 178, 0.2) 100%)",
    // +1相关样式开始
    "evaluate-bg": "linear-gradient(to left, #8e54ca, #f0b0b6 50%, #f9e0b2 0%)",
    "evaluate-num": "unset",
    "text-fill-color": "transparent",
    // +1相关样式结束
    "btn-color":
      "linear-gradient(to left, #8e54ca 0%, #f0b0b6 50%, #f9e0b2 100%)",
  },
  text: {
    haobtn: "好用",
    badbtn: "观望",
  },
  var: {
    appid: "wx04847d842d36ed05",
    hideLoginEntry: false,
    hideMobileLoginEntry: false,
    beian: "京ICP备2021005318号-3",
  },
};

export default GOOD_CONFIG;
